/**
 * Angular imports.
 */
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, OnDestroy } from '@angular/core';

/**
* Service imports.
*/
import { FileUploadService } from '../../dataservices/file-upload.service';
import { MasterserviceService } from '../../dataservices/master-service/masterservice.service';
import { CreateCommunityService } from './../create-community/create-community.service';
import { NewLanguageService } from '../../dataservices/new-language/new-language.service';
/**
 * Constant imports.
 */
import { MEDIA_DIMENSIONS, PRODUCT_TYPE_CONSTANT } from './../../constants/app.constants';
/**
* Rxjs imports.
*/
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-update-community-pic-modal',
  templateUrl: './update-community-pic-modal.component.html',
  styleUrls: ['./update-community-pic-modal.component.scss']
})
export class UpdateCommunityPicModalComponent implements OnInit, OnChanges, OnDestroy {

  @Input() communityData;
  @Input() custom_id;
  @Input() inputFile;
  @Output() cancelUpdateCommunityPic = new EventEmitter();
  @Output() updateCommunityPic = new EventEmitter();

  public images_preview = [];
  public api_in_process = false;
  public product_type = PRODUCT_TYPE_CONSTANT.COMMUNITY;
  /**
   * To unsubscribe data.
   */
  private subscriptions: Subscription = new Subscription();

  /**
   * Necessary instance.
   */
  constructor(
    private fileUs: FileUploadService,
    public masterService: MasterserviceService,
    public multilang: NewLanguageService,
    public createCommunityService: CreateCommunityService) { }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    this.subscriptions.add(this.fileUs.fileUploadaing_failed.subscribe(() => {
      this.api_in_process = false;
    }));

    this.subscriptions.add(this.fileUs.fileUploadProcess.subscribe(data => {
      if (data != '' && data != undefined) {
        if (data.total == data.uploaded) {
          if (this.communityData.id) {
            if (this.communityData && this.communityData.media_list.length > 0) {
              this.communityData.media_list[0]['path'] = data.media.media_url;
              this.communityData.media_list[0]['name'] = data.media.media_name;
              this.communityData.media_list[0]['height'] = MEDIA_DIMENSIONS.HEIGHT;
              this.communityData.media_list[0]['width'] = MEDIA_DIMENSIONS.WIDTH;
              this.communityData.media_list[0]['resolution'] = MEDIA_DIMENSIONS.RESOLUTION;
            } else {
              this.communityData.media_list.push({
                'path': data.media.media_url,
                'name': data.media.media_name,
                'id': 0,
                'height': MEDIA_DIMENSIONS.HEIGHT,
                'width': MEDIA_DIMENSIONS.WIDTH,
                'resolution': MEDIA_DIMENSIONS.RESOLUTION
              });
            }
            this.updateCommunityPic.emit(data);
            this.updateCommunity();
          } else {
            this.updateCommunityPic.emit(data);
          }

        }
      }
    }));
  }

  /**
   * get Image Thumbnail
   */
  getImageThumbnail(imgFile): void {
    let x;
    const reader = new FileReader();
    reader.readAsDataURL(imgFile);
    reader.onloadend = function () {
      const base64data = reader.result.toString();
      x = { local: base64data, obj: imgFile };
    };
    setTimeout(() => {
      this.images_preview = x;
      // console.log(x)
    }, 500);
  }

  /**
   * ngOnChanges
   */
  ngOnChanges(): void {
    this.getImageThumbnail(this.inputFile[0]);
  }

  /**
   * ngOnInit
   */
  cancel(): void {
    this.cancelUpdateCommunityPic.emit(false);
  }

  /**
   * update Community
   */
  updateCommunity(): void {
    let specialityData = [];
    const communityId = this.communityData.id;
    const bannerData = [
      {
        'id': this.communityData.media_list.length ? this.communityData.media_list[0]['id'] : 0,
        'path': this.communityData.media_list[0]['path'],
        'name': this.communityData.media_list[0]['name'],
        'height': this.communityData.media_list[0]['height'],
        'width': this.communityData.media_list[0]['width'],
        'resolution': this.communityData.media_list[0]['resolution']
      }
    ];
    const updateCommunityData = {
      'title': this.communityData.title,
      'description': this.communityData.description,
      'privacy': this.communityData.privacy
    };
    specialityData = [...this.communityData.specialties.map((data) => ({ 'id': data.speciality_id }))];
    this.subscriptions.add(this.createCommunityService.updateCommunity(updateCommunityData, bannerData, specialityData, communityId, false));
  }

  /**
   * file Uploading Process.
   */
  fileUploadingProcess(): void {
    if (this.masterService.isOnline == false) {
      this.masterService.isConnectionModalShown.next('1');
      return;
    }
    this.api_in_process = true;
    this.fileUs.initUpload(this.inputFile[0], 1, 1, this.product_type);
  }

  /**
   * unsubscribe the subscription.
   */
  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

}
